import { render, staticRenderFns } from "./giftTbale.vue?vue&type=template&id=5b778756&scoped=true&"
import script from "./giftTbale.vue?vue&type=script&lang=js&"
export * from "./giftTbale.vue?vue&type=script&lang=js&"
import style0 from "./giftTbale.vue?vue&type=style&index=0&id=5b778756&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b778756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b778756')) {
      api.createRecord('5b778756', component.options)
    } else {
      api.reload('5b778756', component.options)
    }
    module.hot.accept("./giftTbale.vue?vue&type=template&id=5b778756&scoped=true&", function () {
      api.rerender('5b778756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/activity_management/components/giftTbale.vue"
export default component.exports